import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminLogin } from '../../api/client';

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      await adminLogin(password);
      nav('/admin/analytics');
    } catch {
      setErr('Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrap">
      <form className="admin-login" onSubmit={submit}>
        <h2>Admin</h2>
        <p className="muted">Enter the admin password (set via ADMIN_PASSWORD env var).</p>
        <input
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        {err && <div className="error-msg">{err}</div>}
        <div className="form-actions">
          <Link to="/" className="pill-btn">Cancel</Link>
          <button type="submit" className="pill-btn primary" disabled={loading}>
            {loading ? '…' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
}
